export default {"src":"/_next/static/media/bell.106d1e19.svg","height":18,"width":14,"blurWidth":0,"blurHeight":0};